import styled, { css, keyframes } from 'styled-components';
import SpriteSVG from '@components/1-atoms/SpriteSVG';

const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
`;

export const InlineImageSkeleton = styled.div`
  width: 100%;
  /* Match approximate screenshot aspect ratio so layout is stable while fetching */
  aspect-ratio: 16 / 9;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  margin: ${({ theme }) => theme.spacing.level4} 0;

  ${({ theme }) => css`
    background: linear-gradient(
      90deg,
      ${theme.colors.surfaceContainerHigh} 25%,
      ${theme.colors.surfaceContainer}     50%,
      ${theme.colors.surfaceContainerHigh} 75%
    );
  `}
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
`;

export const ArtifactFigure = styled.figure`
  margin: ${({ theme }) => theme.spacing.level4} 0;
`;

export const ArtifactCaption = styled.figcaption`
  ${({ theme }) => theme.font.bodySmall};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  margin-top: ${({ theme }) => theme.spacing.level1};
  text-align: center;
`;

export const DownloadCard = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  padding: ${({ theme }) => theme.spacing.level3} ${({ theme }) => theme.spacing.level4};
  margin: ${({ theme }) => theme.spacing.level4} 0;
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.surfaceContainerLow};
  cursor: pointer;
  width: 100%;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceContainerHigh};
  }
`;

export const DownloadCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const DownloadCardName = styled.span`
  ${({ theme }) => theme.font.bodyMedium};
  color: ${({ theme }) => theme.colors.onSurface};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DownloadCardMeta = styled.span`
  ${({ theme }) => theme.font.bodySmall};
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const StyledDownloadIcon = styled(SpriteSVG)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  fill: ${({ theme }) => theme.colors.primary};
`;

export const ModerationBlockedWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.level4} 0;
`;
